const MAX_SEGMENT_LENGTH = 120;

export function normalizeTitleSegment(segment: string): string {
  const trimmed = segment.replace(/\s+/g, ' ').trim();
  if (!trimmed) {
    return '';
  }
  if (trimmed.length <= MAX_SEGMENT_LENGTH) {
    return trimmed;
  }
  return `${trimmed.slice(0, MAX_SEGMENT_LENGTH - 1)}…`;
}

/** `(3) Lớp 10A | Giỏi Tiếng Anh` when unread > 0. */
export function formatDocumentTitle(
  pageSegment: string,
  unreadCount: number,
  brandTitle: string,
): string {
  const segment = normalizeTitleSegment(pageSegment);
  const brand = normalizeTitleSegment(brandTitle) || 'Giỏi Tiếng Anh';
  const unreadPrefix = unreadCount > 0 ? `(${unreadCount}) ` : '';
  const head = segment ? `${unreadPrefix}${segment}` : unreadPrefix ? `${unreadPrefix}${brand}`.trim() : brand;
  return `${head} | ${brand}`;
}
